import React from "react";
import PropTypes from "prop-types";

const Expert = ({name, title, image, url}) => {
    return (
        <div className="w-1/2 lg:w-1/4 px-5 mb-12">
            <div
                className="hover-up-5 pt-8 pb-8 px-4 text-center bg-white rounded shadow animate__animated animate__fadeIn animated border border-gray-100 hover:border-gray-200"
                data-wow-delay=".1s"
            >
                <img
                    className="mb-6 h-24 w-24 mx-auto rounded-full object-cover object-top"
                    src={image}
                    alt={`avatar expert - ${name}`}
                />
                <strong className="mt-6 mb-3 text-md">{name}</strong>
                <p className="text-gray-500 text-xs mt-3">{title}</p>
                <a className="inline-block px-2 mt-3" href={url} target="_blank">
                    <img src="/assets/imgs/icons/linkedin.svg" alt="LinkedIn Logo"/>
                </a>
            </div>
        </div>
    );
};

Expert.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    url: PropTypes.string,
};

export default Expert;
